import * as React from 'react';
import { IStringLocalizer } from '../../../utilities/IStringLocalizer';
import { useLocalizer } from './hooks/useLocalizer';

interface AINextStepsProps {
    localizer?: IStringLocalizer;
}

/**
 * Component displaying next steps information after file upload
 */
export const AINextSteps: React.FC<AINextStepsProps> = ({ localizer }) => {
    const localize = useLocalizer(localizer);

    return (
        <div className="ai-next-steps m-t-10">
            <div className="ai-next-steps-title">
                <b>{localize("Next Steps:")} </b>
                {localize("After uploading, proceed through the survey to validate AI-suggested answers based on your documents.")}
            </div>
        </div>
    );
};

export default AINextSteps;
